import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgCustomFields = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 49,
	height: 49,
	viewBox: "0 0 49 49",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M18.3218 8.81445C12.5162 8.81445 8.94977 9.00619 8.95034 17.5797C8.95076 23.7104 8.9505 28.9087 8.95033 32.5603C8.95025 34.1295 8.95019 35.4132 8.9502 36.3624C8.95022 38.2407 9.4139 42.6233 15.9287 42.6233C20.7299 43.1242 28.7129 42.832 33.2474 42.6233H36.2709C42.7223 42.6233 42.6942 38.6036 42.6803 36.6136C42.6797 36.5258 42.6791 36.4418 42.6791 36.3624C42.6792 35.4067 42.6791 34.1119 42.679 32.528C42.6788 28.878 42.6786 23.6923 42.679 17.5797C42.6796 9.00619 37.4331 8.81445 34.2322 8.81445H31.6618H18.3218ZM17.6396 12.7234C16.9698 13.8834 17.383 15.3758 18.5624 16.0567C19.7417 16.7377 21.2408 16.3493 21.9105 15.1892C22.5803 14.0292 22.2801 12.4401 21.1007 11.7592C19.9213 11.0782 18.3093 11.5633 17.6396 12.7234ZM25.1891 21.997C24.518 23.1595 24.932 24.655 26.1139 25.3374C27.2958 26.0197 28.7979 25.6305 29.4691 24.468C30.1403 23.3056 29.7262 21.81 28.5444 21.1277C27.3625 20.4453 25.8603 20.8345 25.1891 21.997ZM22.387 34.9418C23.5689 34.2594 23.9829 32.7639 23.3118 31.6014C22.6406 30.4389 21.1384 30.0497 19.9565 30.7321C18.7747 31.4144 18.3607 32.91 19.0318 34.0724C19.703 35.2349 21.2052 35.6241 22.387 34.9418Z",
			fill: "#FFD000"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.31851 14.983C7.31792 6.26719 10.9435 6.07227 16.8455 6.07227H30.4068H33.0199C36.2738 6.07227 41.6074 6.26719 41.6068 14.983C41.6062 23.8937 41.607 30.8668 41.607 34.0773C41.6069 35.9867 41.9405 40.4421 35.0924 40.4421H32.0187C27.4089 40.6543 19.2936 40.9513 14.4126 40.4421C7.78975 40.4421 7.31838 35.9867 7.31836 34.0773C7.31832 30.8668 7.31911 23.8937 7.31851 14.983Z",
			stroke: "#1B1B20",
			strokeWidth: 2.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.2363 23.0724C15.8953 22.8787 18.2885 23.0724 20.6769 23.0724C23.3117 23.0724 21.8886 23.2662 23.7427 23.0724",
			stroke: "#1B1B20",
			strokeWidth: 2.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M31.0142 23.0732C31.0142 23.0732 32.7577 23.0732 33.1568 23.0732C33.5971 23.0732 34.0796 23.0732 34.6918 23.0732",
			stroke: "#1B1B20",
			strokeWidth: 2.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 27.3289,
			cy: 23.2331,
			rx: 3.26872,
			ry: 3.32325,
			transform: "rotate(120 27.3289 23.2331)",
			stroke: "#1B1B20",
			strokeWidth: 2.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.501 13.7979H15.866",
			stroke: "#1B1B20",
			strokeWidth: 2.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.501 32.7637H17.4496",
			stroke: "#1B1B20",
			strokeWidth: 2.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23.2783 13.9802C23.2783 13.9802 27.8669 13.9802 28.289 13.9802C28.7545 13.9802 34.364 13.9916 34.6916 13.7979",
			stroke: "#1B1B20",
			strokeWidth: 2.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24.8174 32.7598C24.8174 32.7598 26.5162 32.7595 28.9855 32.7595C31.4547 32.7595 34.3616 32.5744 34.6917 32.7598",
			stroke: "#1B1B20",
			strokeWidth: 2.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.203 16.6795C16.6843 15.8027 16.1523 13.8809 17.0147 12.387C17.8772 10.8932 19.953 10.2685 21.4718 11.1454C22.9905 12.0222 23.377 14.0686 22.5146 15.5624C21.6521 17.0562 19.7218 17.5564 18.203 16.6795Z",
			stroke: "#1B1B20",
			strokeWidth: 2.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 3.4789,
			cy: 3.53694,
			rx: 3.4789,
			ry: 3.53694,
			transform: "matrix(0.5 0.866025 0.866025 -0.5 16.3687 31.5928)",
			stroke: "#1B1B20",
			strokeWidth: 2.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgCustomFields;
